import startCase from 'lodash.startcase'

import { CreateAccountMutationVariables } from 'src/config/generated/graphql'
import {
  BusinessSize,
  BusinessType,
  FocusAreaType,
  GovernmentType,
  OrganisationType,
  SchoolTertiaryType,
  SectorType
} from 'src/types/account'
import { enumToArray } from 'src/utils/common'
import { DEFAULT_SELECT_OPTION } from 'src/utils/form'

import { AccountFormValues, ProfileVisibility } from './types'

export const businessTypeOptions = [
  DEFAULT_SELECT_OPTION,
  ...enumToArray(BusinessType)
    .filter(o => o !== BusinessType[BusinessType.Unknown])
    .map(key => ({
      label: startCase(key),
      value: Object(BusinessType)[key]
    }))
]

export const sectorTypeOptions = [
  DEFAULT_SELECT_OPTION,
  ...enumToArray(SectorType)
    .filter(o => o !== SectorType[SectorType.Unknown])
    .map(key => ({
      label: startCase(key),
      value: Object(SectorType)[key]
    }))
]

export const schoolTypeOptions = [
  DEFAULT_SELECT_OPTION,
  ...enumToArray(SchoolTertiaryType)
    .filter(o => o !== SchoolTertiaryType[SchoolTertiaryType.Unknown])
    .map(key => ({
      label: startCase(key),
      value: Object(SchoolTertiaryType)[key]
    }))
]

export const organisationTypeOptions = [
  DEFAULT_SELECT_OPTION,
  ...enumToArray(OrganisationType)
    .filter(o => o !== OrganisationType[OrganisationType.Unknown])
    .map(key => ({
      label: startCase(key),
      value: Object(OrganisationType)[key]
    }))
]

export const focusAreaTypeOptions = [
  DEFAULT_SELECT_OPTION,
  ...enumToArray(FocusAreaType)
    .filter(o => o !== FocusAreaType[FocusAreaType.Unknown])
    .map(key => ({
      label: startCase(key),
      value: Object(FocusAreaType)[key]
    }))
]

export const governmentOrganisationTypeOptions = [
  DEFAULT_SELECT_OPTION,
  ...enumToArray(GovernmentType)
    .filter(o => o !== GovernmentType[GovernmentType.Unknown])
    .map(key => ({
      label: startCase(key),
      value: Object(GovernmentType)[key]
    }))
]

/*
Self-Employed/Owner-Operator: 1 employee
Micro Business: 2-5 employees
Small Business: 6-19 employees
Medium Business: 20-49 employees
Large Business: 50-199 employees
Enterprise: 200+ employees
*/

export const businessSizeMap: { [key in BusinessSize]: string } = {
  [BusinessSize.SelfEmployed]: '1 employee',
  [BusinessSize.Micro]: '2-5 employees',
  [BusinessSize.Small]: '6-19 employees',
  [BusinessSize.Medium]: '20-49 employees',
  [BusinessSize.Large]: '50-199 employees',
  [BusinessSize.Enterprise]: '200+ employees'
}

export const businessSizeOptions = [
  DEFAULT_SELECT_OPTION,
  ...enumToArray(BusinessSize).map(key => ({
    label: businessSizeMap[key as BusinessSize],
    value: key
  }))
]

export const transformFormData = (values: AccountFormValues, email: string) => {
  const {
    AccountType: accountTypeFormValue,
    FirstName,
    LastName,
    DisplayName,
    Phone
  } = values

  const transformedData: CreateAccountMutationVariables = {
    input: {
      AccountActionType: values.AccountActionType!,
      BusinessType: values?.BusinessType,
      FocusArea: values?.FocusArea,
      GovType: values?.GovType,
      OrgType: values?.OrgType,
      SchoolType: values?.SchoolType,
      Sector: values?.Sector,
      Type: accountTypeFormValue,
      Name: DisplayName,
      Email: email,
      Phone,
      FirstName,
      LastName,
      FunderHidden: values.FunderHidden === ProfileVisibility.Private,
      PlanterHidden: values.PlanterHidden === ProfileVisibility.Private,
      PlanterName: values.PlanterName || values.DisplayName,
      FunderName: values.FunderName || values.DisplayName,
      BusinessSize: values.BusinessSize,
      User: {
        FirstName,
        LastName
      }
    }
  }
  return transformedData
}
